import React from "react";
import { useNavigate, useParams } from "react-router-dom";
import { getBookingCommissionWithId, updateBookingCommission, getBookingTypes } from "adminApi/BookingCommissionApi/BookingCommission";
import { BookingCommissionRules } from "validation/ValidationRules";
import Spinner from "Common/Globle/Spinner";
import EditBookingCommissionForm from "./Components/EditBookingCommissionForm";
import useFormChange from "Hooks/useFormChange";
import useFormSubmit from "Hooks/useFormSubmit";
import useFetchFormDataById from "Hooks/useFetchFormDataById";
import { validateForm } from "utils/validation";
import fields from "../json/BookingCommissionFields.json";
import useFetchAllData from "Hooks/useFetchAllData";

const EditBookingCommission = () => {
    const navigate = useNavigate();
    const { id } = useParams();
    const { formdata } = fields;

    // Build initial values from field definitions
    const initialValues = formdata.reduce((acc, field) => ({ ...acc, [field.name]: "" }), {});

    const { values, errors, handleChange, setValues, setErrors } = useFormChange(
        initialValues,
        BookingCommissionRules
    );

    // Fetch booking types for the select dropdown
    const { data: bookingTypeOptions, loading: loadingTypes } = useFetchAllData(getBookingTypes);

    // Fetch existing record by ID and populate form
    const { loading: loadingFetch } = useFetchFormDataById(
        id,
        formdata,
        getBookingCommissionWithId,
        setValues
    );

    const { loading: loadingSubmit, handleSubmit } = useFormSubmit(
        // Send plain JSON — no file uploads in this form
        async (formValues) => await updateBookingCommission({ id, data: formValues }),
        (vals) => {
            const err = validateForm(vals, BookingCommissionRules);
            setErrors(err);
            return err;
        },
        () => navigate(-1),
        "Booking Commission Updated Successfully"
    );

    return (
        <>
            {(loadingSubmit || loadingFetch || loadingTypes) && <Spinner isSpinner={true} />}
            <EditBookingCommissionForm
                fields={formdata}
                values={values}
                errors={errors}
                handleChange={handleChange}
                handleSubmit={(e) => handleSubmit(e, values)}
                loading={loadingSubmit}
                bookingTypeOptions={bookingTypeOptions || []}
            />
        </>
    );
};

export default EditBookingCommission;
